import React from 'react';
import { LOGO_URL } from './navData';
export function Logo() {
  return <a href="/" className="flex-shrink-0 -ml-2" data-id="element-96">
      <img src={LOGO_URL} alt="Medina Tactical Dynamics" className="block h-[4.5rem] w-auto" data-id="element-97" />
    </a>;
}